var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "field",
      class: [
        {
          "has-error": _vm.v && _vm.v.$anyError,
          "is-required": _vm.isRequired,
        },
        _vm.classes,
        _vm.name ? _vm.name : "",
      ],
      attrs: { disabled: _vm.iniDisabled },
    },
    [
      _vm.showLabel && _vm.label
        ? _c("label", { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "field has-addons": !!this.$slots.append || !!this.$slots.prepend,
          },
        },
        [
          !!this.$slots.prepend
            ? _c("div", { staticClass: "control" }, [_vm._t("prepend")], 2)
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control is-expanded" },
            [
              _vm.type == "CHECKBOX"
                ? [
                    _c("div", { staticClass: "checkbox" }, [
                      _c(
                        "label",
                        { staticClass: "b-checkbox checkbox d-inline" },
                        [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              autocomplete: "on",
                              "true-value": "true",
                              disabled: _vm.iniDisabled,
                            },
                            domProps: {
                              value: _vm.selected,
                              checked: _vm.selected,
                            },
                            on: { input: _vm.onCheckBoxChange },
                          }),
                          _c("span", { staticClass: "check" }),
                          _c("span", { staticClass: "control-label" }, [
                            _vm._v(_vm._s(_vm.label)),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                : _vm.type == "COUNTRY"
                ? [
                    _c("selectCountries", {
                      attrs: { isDisabled: _vm.iniDisabled },
                      on: { input: _vm.onValueChange },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    }),
                  ]
                : _vm.type == "NATIONALITY"
                ? [
                    _c("selectNationality", {
                      attrs: {
                        isDisabled: _vm.iniDisabled,
                        editMode: _vm.iniDisabled,
                      },
                      on: { input: _vm.onValueChange },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    }),
                  ]
                : _vm.type == "TOGGLE"
                ? [
                    _c("toggleButton", {
                      attrs: {
                        color: _vm.color,
                        label: _vm.label,
                        iniDisabled: _vm.iniDisabled,
                      },
                      on: { input: _vm.onToggleChange },
                      model: {
                        value: _vm.selected,
                        callback: function ($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected",
                      },
                    }),
                  ]
                : _vm.type == "SELECT"
                ? [
                    _vm.renderAsChecks
                      ? _vm._l(_vm.options, function (option, i) {
                          return _c(
                            "div",
                            { key: `${_vm._uid}_${i}`, staticClass: "field" },
                            [
                              _c("div", { staticClass: "checkbox" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "d-inline",
                                    class: _vm.isMultiple
                                      ? "b-checkbox checkbox"
                                      : "b-radio radio",
                                    attrs: { disabled: _vm.iniDisabled },
                                  },
                                  [
                                    _c("input", {
                                      attrs: {
                                        name: _vm._uid,
                                        type: _vm.isMultiple
                                          ? "checkbox"
                                          : "radio",
                                        disabled: _vm.iniDisabled,
                                      },
                                      domProps: {
                                        value: _vm.optionsValueField
                                          ? option[_vm.optionsValueField]
                                          : option,
                                        checked:
                                          _vm.value &&
                                          _vm.value.indexOf(
                                            _vm.optionsValueField
                                              ? option[_vm.optionsValueField]
                                              : option
                                          ) > -1,
                                      },
                                      on: { input: _vm.onChangeAsChecks },
                                    }),
                                    _c("span", { staticClass: "check" }),
                                    _c(
                                      "span",
                                      { staticClass: "control-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.optionsTextField
                                              ? option[_vm.optionsTextField]
                                              : option
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        })
                      : [
                          _c("div", { staticClass: "control is-expanded" }, [
                            _c(
                              "span",
                              {
                                staticClass: "select is-fullwidth",
                                class: { "is-multiple": _vm.isMultiple },
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selected,
                                        expression: "selected",
                                      },
                                    ],
                                    attrs: {
                                      multiple: _vm.isMultiple,
                                      disabled: _vm.iniDisabled,
                                      size: _vm.isMultiple ? 4 : 0,
                                    },
                                    on: {
                                      input: _vm.onChange,
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selected = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    !_vm.iniDisabled && !_vm.disablePlaceholder
                                      ? [
                                          _vm.selected == null
                                            ? _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    disabled: "",
                                                    hidden: "",
                                                  },
                                                  domProps: { value: null },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.placeholder
                                                          ? _vm.placeholder
                                                          : _vm.$t("choose")
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.options,
                                      function (option, index) {
                                        return _c(
                                          "option",
                                          {
                                            key: `${_vm._uid}__${index}`,
                                            domProps: {
                                              value: _vm.optionsValueField
                                                ? option[_vm.optionsValueField]
                                                : option,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.optionsTextField
                                                    ? option[
                                                        _vm.optionsTextField
                                                      ]
                                                    : option
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                          ]),
                        ],
                  ]
                : _vm.type == "CUSTOM"
                ? [_vm._t("custom")]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          !!this.$slots.append
            ? _c("div", { staticClass: "control" }, [_vm._t("append")], 2)
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.v && _vm.v.$anyError
        ? _c("span", { staticClass: "help is-danger" }, [_vm._t("onError")], 2)
        : _vm._e(),
      _vm._v(" "),
      !!this.$slots.help
        ? _c("span", { staticClass: "help info" }, [_vm._t("help")], 2)
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }